export class Dividend {
    type:string | undefined;
    url:string | undefined;
    code:string | undefined;
    name:string | undefined;
    title:string | undefined;
    lang:string | undefined;
    country:string | undefined;

    regstrDt:Date | undefined;
    cashDvdndH:number | undefined;
    cashDvdndDt:Date | undefined;
    cashDvdndB:number | undefined;
    capital:number | undefined;
    cashDvdnd:number | undefined;
    spk:boolean | undefined;
    apply:boolean | undefined;
    ntn:string | undefined;
    ntb:number | undefined;
    limit:number | undefined;

    createDate:Date | undefined;
    order:number | undefined;
    startDate:Date | undefined;
    endDate:Date | undefined;
    commentCount:number | undefined;
    completeStatus:boolean | undefined;
}
